import { render } from "./EmberPage.vue?vue&type=template&id=8bafd6fe&scoped=true"
import script from "./EmberPage.vue?vue&type=script&lang=js"
export * from "./EmberPage.vue?vue&type=script&lang=js"

import "./EmberPage.vue?vue&type=style&index=0&id=8bafd6fe&lang=scss&scoped=true"
import "./EmberPage.vue?vue&type=style&index=1&id=8bafd6fe&lang=scss"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bafd6fe"]])

export default __exports__